import "antd/dist/antd.css";
import "../../../assests/style.css";
import React, { useState, useEffect, useReducer } from "react";
import { Row, Col } from "antd";
import { initialState, reducer } from "./reducer";
import { useSelector } from "react-redux";
import Search from "./components/Search";
import ReferredList from "./components/List";
import PatronagerService from "../../../../services/Election/Patronage/PatronagerService";
import moment from "moment";
import SimpleHeader from "../../../../helpers/cards-helper/SimpleHeader";
import NewAdd from "./components/NewAdd";




const PatronageReferred = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const token = useSelector((state) => state.Member.token);
    const [searchLoading, setSearchLoading] = useState(false);


    useEffect(() => {
        updateLoading(true);
        setSearchLoading(true);
        PatronagerService.getReferredList(state.filters, token)
            .then((response) => {
                const itemsList = response.data.data.map((item) => {
                    return {
                        ...item,
                        name: item?.voter?.name,
                        surname: item?.voter?.surname,
                        full_name: item?.member?.name + " " + item?.member?.surname,
                        phone: item?.voter?.phone,
                        qv_code: item?.voter?.qv?.code,
                        list_number: item?.voter?.list_number,
                        building_no: item?.voter?.building_number,
                        birthdate: moment(item?.voter?.dob).format("DD-MM-YYYY"),
                    };
                });

                const itemsCount = response.data.count;
                const action = {
                    type: "set_items",
                    payload: {
                        items: itemsList,
                        total: itemsCount,
                    },
                };
                dispatch(action);
                updateLoading(false);
                setSearchLoading(false);
            })
            .catch((err) => {
                updateLoading(false);
                setSearchLoading(false);
            });
    }, [token, state.filters]);


    const updateLoading = (isLoading) => {
        const action = {
            type: "set_loading",
            payload: isLoading,
        };
        dispatch(action);
    };


    const refreshList = () => {
        const action = {
            type: "refresh_list",
        };
        dispatch(action);
    };


    const updateIndexVisibility = (indexVisibility) => {
        const action = {
            type: "set_index_visibility",
            payload: indexVisibility,
        };
        dispatch(action);
    };


    const onSuccess = () => {
        refreshList();
        updateIndexVisibility(0);
    };


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>

                {state.indexVisibility === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <SimpleHeader
                                title={"Të referuarit"}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <Search
                                dispatch={dispatch}
                                initialFilters={state.filters.searchFilters}
                                searchLoading={searchLoading}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <ReferredList
                                dispatch={dispatch}
                                items={state.items}
                                totalCount={state.totalCount}
                                initialPagination={state.filters.pagination}
                                filters={state.filters}
                                isLoading={state.isLoading}
                                onRefreshList={() => refreshList()}
                                onSuccess={onSuccess}
                                onAdd={() => updateIndexVisibility(1)}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 1 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <NewAdd
                                onSuccess={onSuccess}
                                onBack={() => updateIndexVisibility(0)}
                            />
                        </Col>
                    </Row>
                )}

            </Col>
        </Row>
    );
};


export default PatronageReferred;